<template>
  <div style="min-height: 85vh; overflow: hidden" @click="clearThings()">
    <div class="el-icon-s-home" style="margin: 15px 20px; font-size: 22px; cursor: pointer">
      <span v-for="(r, index) in route" :key="index" style="font-size: 18px">
        <!--        <span v-if="r.id" @click="handleClick(r.id, null, null, true, index)">>{{r.name.slice(0,4)}}...</span>-->
        <!--        <span v-else @click="handleClick(r.id, null, null, true, 0)">>{{r.name}}</span>-->
        <span @click="handleClick(r.id, null, null, true, 0)">>{{r.name}}</span>
      </span>
    </div>
    <div style="margin: 15px 20px; float: right">
      <div
          class="el-icon-user-solid"
          style="float: left; margin-right: 30px; font-size: 22px; cursor: pointer"
          @click="$refs.panRoleEdit.open()"
      />
      <pan-role-edit ref="panRoleEdit" @save-success="getData()"/>
      <div v-if="releaseAuth" style="float: left; margin-right: 30px; font-size: 22px; cursor: pointer">
        <el-upload
            action=""
            :http-request="submitUpload"
            :before-upload="beforeUpload"
            :on-error="handlerError"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            multiple
            :disabled="uploadLoading"
            :show-file-list="false"
            accept=".*"
            style="display: inline-block"
        >
          <i class="el-icon-upload2"/>{{uploadPercent}}
        </el-upload>
      </div>
      <div v-if="releaseAuth" class="el-icon-plus" style="float: left; margin-right: 30px; font-size: 22px; cursor: pointer" @click="handleAdd()"/>
      <div v-if="releaseAuth" class="el-icon-delete" style="float: left; margin-right: 30px; font-size: 22px; cursor: pointer" @click="batchDelete(data)"/>
    </div>
    <hr style="border: 1px dashed #000">
    <div style="clear: both"/>
    <div
        v-for="item in data"
        :key="item.id"
        v-popover:item.id
        style="
        margin: 20px 0px 40px 40px;
        width: 200px;
        height: 120px;
        float: left;
        text-align: center;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      "
        @dblclick="handleClick(item.id, item.name, item.type, false, null)"
        @contextmenu.prevent="handleRightClick(item.id)">
      <div v-if="item.type === 16" class="el-icon-folder-opened" style="font-size: 80px; color: #2d8cf0; margin: 0 auto"/>      <div v-else class="el-icon-document" style="font-size: 80px; color: #000; margin: 0 auto"/>
      <div v-if="renameVisible && item.id === rightClickId" style="width: 100px; font-size: 14px; margin: 0 auto" @click.stop="1">
        <el-input v-model="item.name" autosize type="textarea" @blur="doRename(item.id, item.name)"/>
      </div>
      <div v-else style="font-size: 14px; margin: 0 auto">{{item.name}}</div>
      <el-popover
          :ref="item.id"
          :value="rightClickVisible && item.id === rightClickId"
          placement="bottom"
          width="150"
          trigger="manual">
        <div style="width: 100%; text-align: center">
          <div v-if="item.type === 128">
            <el-popover placement="right" trigger="hover">
              <vue-qr
                  :size="180"
                  :margin="5"
                  :text="getDownLoadUrl(item.id)"
                  logo-src="/img/step_cc.png"
                  :logo-scale="1.5"/>
              <el-button
                  slot="reference"
                  style="margin: 5px auto"
                  type="text"
                  @click.stop="downLoad(item.id)">
                <span style="font-size: 16px">下载</span>
              </el-button>
            </el-popover>
          </div>
          <div v-if="item.type === 128 && item.name.indexOf('.pdf') > 0">
            <el-popover placement="right" trigger="hover">
              <vue-qr
                  :size="180"
                  :margin="5"
                  :text="getReadUrl(item.id)"
                  logo-src="/img/step_cc.png"
                  :logo-scale="1.5"/>
              <el-button
                  slot="reference"
                  style="margin: 5px auto"
                  type="text"
                  @click.stop="read(item.id)">
                <span style="font-size: 16px">阅读</span>
              </el-button>
            </el-popover>
          </div>
          <div>
            <el-button
                type="text"
                style="margin: 5px auto"
                @click.stop="handleRename(item.id)">
              <span style="font-size: 16px">重命名</span>
            </el-button>
          </div>
          <div>
            <el-button
                type="text"
                style="margin: 5px auto"
                @click="$refs.panRemoveDialog.open()">
              <span style="font-size: 16px">移动</span>
            </el-button>
          </div>
          <div>
            <el-upload
                :action="uploadBaseUrl + 'pans/replaceFile/' + item.id"
                :before-upload="beforeUpload"
                :on-error="handlerError"
                :on-success="handleSuccess"
                :multiple="false"
                :show-file-list="false"
                accept=".*"
                style="display: inline-block">
              <el-button type="text" style="margin: 5px auto">
                <span style="font-size: 16px">替换</span>
              </el-button>
            </el-upload>
          </div>
          <div>
            <el-button
                type="text"
                style="margin: 5px auto">
              <span style="font-size: 16px" @click.stop="handleDelete(item.id)">删除</span>
            </el-button>
          </div>
        </div>
      </el-popover>
    </div>
    <a ref="fileDownLoad" target="_blank" download="1" href="#"/>
    <pan-remove-dialog ref="panRemoveDialog" @select="doRemove"/>
    <pan-batch-delete ref="batchDelete" @select="getData"/>
  </div>
</template>
<script>
  import PanRoleEdit from "./PanRoleEdit";
  import PanRemoveDialog from "./PanRemoveDialog.vue";
  import vueQr from "vue-qr";
  import loginUtil from "@/util/loginUtil";
  import PanBatchDelete from "@/views/document/Pan/PanBatchDelete";

  export default {
    name: "Pan",
    components: {PanBatchDelete, PanRoleEdit, PanRemoveDialog, vueQr },
    data() {
      return {
        releaseAuth: this.$auth(649),
        uploadBaseUrl: window.config.basicServerHttpUrl,
        uploadPercent: "",
        uploadLoading: false,
        route: [{ name: "$:我的资料", id: null }],
        parentId: 0,
        data: [],
        rightClickVisible: false,
        rightClickId: 0,
        renameVisible: false,
        renameId: 0,
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        let params = {
          parentId: this.parentId,
        };
        this.$http.get("basic", "pans", params).then((resp) => {
          console.log(resp);
          this.data = resp;
        });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        // formData.append("Authorization", loginUtil.getToken());
        let parentId = this.parentId === null ? 0 : this.parentId;
        this.$http
          .post("basic", "pans/uploadFile/" + parentId, formData)
          .then((res) => {
            this.uploadLoading = false;
            this.getData();
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      handleClick(id, name, type, isRoute, index) {
        if (this.rightClickVisible) {
          this.rightClickVisible = !this.rightClickVisible;
        }
        if (type == 16 || isRoute) {
          if (!isRoute) {
            this.route.push({ name: name, id: id });
          } else {
            this.route.splice(index + 1, this.route.length);
          }
          this.parentId = id;
          this.getData();
        }
      },
      handleRightClick(id) {
        this.rightClickVisible = !this.rightClickVisible;
        this.rightClickId = id;
        this.renameVisible = false;
      },
      handleRename(id) {
        this.rightClickVisible = false;
        this.renameVisible = true;
        this.renameId = id;
      },
      clearThings() {
        this.rightClickVisible ? (this.rightClickVisible = false) : this.rightClickVisible;
        this.renameVisible ? (this.renameVisible = false) : this.renameVisible;
      },
      doRename(id, name) {
        let params = {
          id: id,
          name: name,
        };
        this.$http
          .save("basic", "pans", params)
          .then(() => {})
          .catch(() => {
            this.$message.error("重命名失败");
          });
      },
      handleAdd() {
        let params = {
          parendId: this.parentId,
          type: 16,
          name: "新建文件夹",
        };
        this.$http.save("basic", "pans", params).then(() => {
          this.getData();
        });
      },
      batchDelete() {
        this.$refs.batchDelete.open(this.data);
      },
      handleDelete(id) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "pans", id).then(() => {
            this.getData();
          });
        });
      },
      doRemove(obj) {
        let params = {
          id: this.rightClickId,
          parendId: obj.id,
        };
        this.$http.save("basic", "pans", params).then(() => {
          this.getData();
        });
      },
      getDownLoadUrl(id) {
        let url = window.config.basicServerHttpUrl + "pans/downLoadFile?id=" + id;
        console.log(url);
        return url;
      },
      downLoad(id) {
        let url = window.config.basicServerHttpUrl + "pans/downLoadFile?id=" + id;
        this.$refs.fileDownLoad.href = url;
        this.$refs.fileDownLoad.click();
      },
      getReadUrl(id) {
        let url = "http://" + window.location.host + "/#/pdf?id=" + id;
        console.log(url);
        return url;
      },
      read(id) {
        window.open("#/pdf?id=" + id);
      },
      onProgress(event) {
        this.uploadLoading = true;
        this.uploadPercent = Math.round(event.percent) + "%";
      },
      beforeUpload(file) {
        let size = file.size / 1024 / 1024;
        if (size > 300) {
          this.$message.error("文件不能超过 300MB!");
          return false; // 返回false中止上传
        }
      },
      handleSuccess() {
        this.$message.success("上传成功");
        this.getData();
        this.uploadLoading = false;
        this.uploadPercent = "";
      },
      handlerError(err) {
        this.$message.error(err.message);
        this.uploadLoading = false;
        this.uploadPercent = "";
      },
    },
  };
</script>
<style lang="scss" scoped></style>
